<div class="maint-container">
  <div class="cle-main">
    <app-site-header headerText='State Disciplinary Board E-Filing Portal'></app-site-header>
  </div>
  <div class="maint-content" style="margin-top: 20px;">
    <span class="maint-text">The Portal is undergoing scheduled maintenance.  Please try back again later.</span>
    <span class="maint-text">If you have questions please call Jessica Oglesby at 404-527-8721</span>
  </div>
</div>
